import { Grid, NumberInput } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'

type PlaceValues = {
  place: {
    rack: number
    column: number
    shelf: number
  }
}

type Props<Values extends PlaceValues> = {
  form: UseFormReturnType<Values>
  disabled?: boolean
}

export default function PlaceInput<Values extends PlaceValues>({ form, disabled }: Props<Values>) {
  return (
    <Grid>
      <Grid.Col span={4}>
        <NumberInput
          label="Regał"
          placeholder="1"
          allowNegative={false}
          allowDecimal={false}
          clampBehavior="strict"
          hideControls
          withAsterisk
          disabled={disabled}
          {...form.getInputProps('place.rack')}
        />
      </Grid.Col>
      <Grid.Col span={4}>
        <NumberInput
          label="Kolumna"
          placeholder="2"
          allowNegative={false}
          allowDecimal={false}
          clampBehavior="strict"
          hideControls
          withAsterisk
          disabled={disabled}
          {...form.getInputProps('place.column')}
        />
      </Grid.Col>
      <Grid.Col span={4}>
        <NumberInput
          label="Półka"
          placeholder="3"
          allowNegative={false}
          allowDecimal={false}
          clampBehavior="strict"
          hideControls
          withAsterisk
          disabled={disabled}
          {...form.getInputProps('place.shelf')}
        />
      </Grid.Col>
    </Grid>
  )
}
